import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './auth/authProvider'
import { initMsal } from './auth/msalConfig'
import { BrandingProvider } from './branding/BrandingContext'
import { ToastProvider } from './components/Toast'
import { createQueryClient } from './lib/queryClient'
import App from './App'
import './index.css'
import './styles/vitals.css'
// Responsive layer (tablet/mobile reflow: sidebar→topbar, table scroll, hero
// stacking, grid/form collapse). Loaded AFTER vitals.css so it wins on equal
// specificity. Was previously authored but never imported — #5. */
import './styles/app.css'
import { registerServiceWorker } from './pwa/registerServiceWorker'
import { dismissBootSplash } from './boot'

// Befund 35: zentraler Client mit globalem Mutations-Fehler-Toast (lib/queryClient.ts).
const qc = createQueryClient()

async function main() {
  await initMsal()

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <QueryClientProvider client={qc}>
          <BrandingProvider>
            <ToastProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ToastProvider>
          </BrandingProvider>
        </QueryClientProvider>
      </AuthProvider>
    </React.StrictMode>,
  )
  requestAnimationFrame(() => dismissBootSplash())
  void registerServiceWorker()
}

main()
